/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Swift_Raven_GazeInputs */

const en_keen_swift_raven_gaze = /** @type {(inputs: Keen_Swift_Raven_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versions`)
};

const de_keen_swift_raven_gaze = /** @type {(inputs: Keen_Swift_Raven_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionen`)
};

/**
* | output |
* | --- |
* | "Versions" |
*
* @param {Keen_Swift_Raven_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_swift_raven_gaze = /** @type {((inputs?: Keen_Swift_Raven_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Swift_Raven_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_swift_raven_gaze(inputs)
	return de_keen_swift_raven_gaze(inputs)
});